<template>
  <b-form @submit.prevent="save">
    <SettingsTitleBar sub="Billing" @cancel="cancel" :saving="saving" :buttons="editing ? 'both' : 'cancel'" />
    <b-alert :show="!!notification.type" :variant="notification.type">{{notification.message}}</b-alert>
    <div v-if="forceInvoice">
      <p>Your team has invoicing enabled</p>
      <ActionButton v-if="isStaff" action="updateTeam" :arg="{allow_invoice: false}">Disable invoicing</ActionButton>
    </div>
    <div v-else-if="editing">
      <h2>Credit Card</h2>
      <EditSavedCard v-if="editing.id" v-model="editing">
        <p id="edit-card">
        Please review the saved card information below. To change the card number or billing address, please delete this
        saved card and create a new one.
        </p>
      </EditSavedCard>
      <NewSavedCard v-else v-model="editing" >
        <p id="edit-card">
        Enter saved card information below. Once you do, your card information will be securely stored and
        available for anyone on your team to use during checkout.
        </p>
      </NewSavedCard>

      <SettingsButtons :saving="saving" bottom/>
    </div>
    <div v-else>
      <div v-if="hasSavedCards">
        <SavedCard v-for="card in savedCards" :card="card" :key="card.id">
          <div class="card-buttons">
            <div v-if="isOwner(card)" @click="edit(card)" class="pointer" v-b-tooltip.hover title="Edit card"><i class="fa fa-edit"/></div>
            <div v-if="isOwner(card)" @click="del(card)" class="pointer" v-b-tooltip.hover title="Delete card"><i class="fa fa-trash"/></div>
            <div v-if="card.available_to_team" v-b-tooltip.hover title="Team card"><i class="fas fa-users"/></div>
            <div v-else v-b-tooltip.hover title="Personal card"><i class="fas fa-user"/></div>
          </div>
        </SavedCard>
        <b-button variant="primary" @click="add">Add another saved card</b-button>
      </div>
      <WaveSpinner v-else-if="loading" />
      <div v-else>
        <p id="no-card">
        You can add a saved card that is used by your team below.
        Anyone on your team will be able to use this card.
        </p>
        <b-button variant="primary" @click="add">Add a saved card</b-button>
        <ActionButton v-if="isStaff" action="updateTeam" :arg="{allow_invoice: true}">Enable invoicing</ActionButton>
      </div>
    </div>
  </b-form>
</template>
<style lang="scss" scoped>
@import '~scss/colors';
h2 {
 margin-top:1em;
}
#edit-card {
  margin: 1em 0;
}

.card-buttons {
  color: #aaa;
}

.btn.btn-primary {
  background: $red;
  color:$white;
  border: $red 1px solid;
  line-height: 20px;
}

</style>
<script>
import { mapGetters, mapActions } from "vuex";
import SavedCard from './billing/SavedCard.vue';
import NewSavedCard from './billing/NewSavedCard.vue';
import EditSavedCard from './billing/EditSavedCard.vue';
export default {
  components: {SavedCard, NewSavedCard, EditSavedCard},
  data() {
    return {
      loading: false,
      editing: null,
      saving: false,
      notification: {message: '', type: ''},
    };
  },
  async mounted() {
    this.loadUserAddresses();

    this.loading = true;
    await this.loadSavedCards();
    this.loading = false;
    if (!this.hasSavedCards && !this.forceInvoice) {
      // No card on file -- alert user
      this.notification = {
        // TODO should be info but doesn't look right
        type: 'warning',
        message: 'No cards on file'
      };
    }
  },
  computed: {
    ...mapGetters(['user', 'savedCards', 'isStaff', 'forceInvoice', 'userAddresses']),
    defaultAddress() {
      // Return the users' default for shipping address,
      // or the first address, or null
      const addresses = this.userAddresses;
      if (!addresses || !addresses.length) return null;
      let address = addresses.find(addr => addr.is_default_for_shipping) || addresses[0];
      // Return only the address fields
      // TODO should we include name?
      let {line1, line2, line3, city, state, postcode, country} = address;
      return {line1, line2, line3, city, state, postcode, country};
    },
    hasSavedCards() {
      return this.savedCards && this.savedCards.length;
    }
  },
  methods: {
    ...mapActions(['loadSavedCards', 'deleteSavedCard', 'addSavedCard', 'editSavedCard', 'loadUserAddresses']),
    cancel(event) {
      if (this.editing) {
        this.editing = null;
        event.preventDefault();
      }
      // otherwise go back to dashboard
    },
    isOwner(card) {
      return card.owner.id === this.user.id;
    },
    add() {
      // Begin adding a card.
      this.editing = {...this.defaultAddress, available_to_team: false};
      this.notification = {};
    },
    edit(card) {
      // Begin editing, from an existing card.
      this.editing = {...card};
      if (!this.editing.line1) {
        // No address, use default
        Object.assign(this.editing, this.defaultAddress);
      }
    },
    async del(card) {
      await this.deleteSavedCard(card.id);
      this.notification = {message: "Card deleted", type: "success"};
    },
    async save() {
      console.log('save!', this.editing);
      this.saving = true;
      try {
        let message;
        if (this.editing.id) {
          message = "Card edited";
          await this.editSavedCard(this.editing);
        } else {
          message = "Card added";
          await this.addSavedCard(this.editing);
        }
        this.editing = null;
        this.notification = {message, type: "success"};
      } catch(e) {
        // Stay in editing mode
        if (typeof e === 'object') {
          // Try to unwrap the object
          if (e.message) e = e.message;
          else e = JSON.stringify(e);
        }
        this.notification = {type: 'danger', message: e};
      }
      this.saving = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/EditBilling.vue